import OTPVerification from 'views/register/otpVerification/OTPVerification.container';

export default OTPVerification;